import ReactDOM from 'react-dom';
import React from 'react';

/**
 * Components.
 */
import Root from 'src/root';

/**
 * Service Worker.
 */
import registerServiceWorker from './registerServiceWorker';

/**
 * Global styles and normalizeCSS.
 */
import 'scss/normalize.scss';
import 'scss/global.scss';

/**
 * @description Renders Root application into the HTML.
 */
ReactDOM.render(<Root />, document.getElementById('app'));
registerServiceWorker();
